var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    overflow: "hidden",
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color1, #ffc531)",
    stroke: "var(--color1, #ffc531)",
    strokeWidth: 2.4,
    d: "M12.4 10.394 16 3.572l3.6 6.822a2.2 2.2 0 0 0 1.571 1.141l7.601 1.315-5.376 5.532a2.2 2.2 0 0 0-.6 1.846l1.098 7.635-6.922-3.404a2.199 2.199 0 0 0-1.941 0l-6.922 3.404 1.098-7.635a2.2 2.2 0 0 0-.6-1.846L3.231 12.85l7.601-1.315a2.202 2.202 0 0 0 1.571-1.141z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-book",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M29.333 8.267c0-1.493 0-2.24-.291-2.811a2.666 2.666 0 0 0-1.165-1.165C27.306 4 26.56 4 25.066 4h-.533c-2.987 0-4.48 0-5.621.581a5.331 5.331 0 0 0-2.331 2.331C16 8.053 16 9.546 16 12.533V28l.133-.2c.926-1.389 1.389-2.084 2.001-2.587a5.345 5.345 0 0 1 1.837-.983c.758-.23 1.593-.23 3.262-.23h1.833c1.494 0 2.24 0 2.811-.291.502-.256.91-.664 1.165-1.165.291-.57.291-1.317.291-2.811V8.266zM2.667 8.267c0-1.493 0-2.24.291-2.811.256-.502.664-.91 1.165-1.165C4.693 4 5.44 4 6.934 4h.533c2.987 0 4.48 0 5.621.581a5.331 5.331 0 0 1 2.331 2.331C16 8.053 16 9.546 16 12.533V28l-.133-.2c-.926-1.389-1.389-2.084-2.001-2.587a5.345 5.345 0 0 0-1.837-.983C11.271 24 10.436 24 8.767 24H6.934c-1.493 0-2.24 0-2.811-.291a2.666 2.666 0 0 1-1.165-1.165c-.291-.57-.291-1.317-.291-2.811V8.266z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "m8 12 8 8 8-8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M24 8 8 24M8 8l16 16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.462,
    d: "M27.787 6.147a7.345 7.345 0 0 0-5.187-2.15 7.33 7.33 0 0 0-5.187 2.15L16 7.56l-1.413-1.413a7.333 7.333 0 0 0-10.374 0 7.333 7.333 0 0 0 0 10.374L16 28.308l11.787-11.787a7.326 7.326 0 0 0 0-10.373z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-out",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M20 4h1.6c2.24 0 3.36 0 4.216.436a3.996 3.996 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4.001 4.001 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H20M13.333 9.333 20 16m0 0-6.667 6.667M20 16H4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ukraine",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338af3",
    d: "M0 16C0 7.164 7.163 0 16 0s16 7.163 16 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-palette",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.484 12q.609 0 1.055-.422t.445-1.078-.445-1.078T17.484 9t-1.055.422-.445 1.078.445 1.078 1.055.422zm-3-3.984q.609 0 1.055-.445t.445-1.055-.445-1.055-1.055-.445-1.055.445-.445 1.055.445 1.055 1.055.445zm-4.968 0q.609 0 1.055-.445t.445-1.055-.445-1.055-1.055-.445-1.055.445-.445 1.055.445 1.055 1.055.445zm-3 3.984q.609 0 1.055-.422t.445-1.078-.445-1.078T6.516 9t-1.055.422-.445 1.078.445 1.078T6.516 12zM12 3q3.703 0 6.352 2.344T21 11.016q0 2.063-1.477 3.516t-3.539 1.453H14.25q-.656 0-1.078.445t-.422 1.055q0 .516.375.984T13.5 19.5q0 .656-.422 1.078T12 21q-3.75 0-6.375-2.625T3 12t2.625-6.375T12 3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.128 5.214A7.908 7.908 0 0 1 11.988 5c1.758 0 3.309.559 4.658 1.393 1.119.692 2.089 1.567 2.894 2.448a18.701 18.701 0 0 1 2.318 3.156 16.723 16.723 0 0 1-1.778 2.542 1 1 0 0 0 1.518 1.302 18.991 18.991 0 0 0 2.283-3.37 1 1 0 0 0 .013-.919s-.396-.789-1.12-1.843a20.553 20.553 0 0 0-1.757-2.218c-.894-.979-2.004-1.987-3.319-2.8C16.103 3.706 14.192 3 12.012 3a9.899 9.899 0 0 0-2.34.266 1 1 0 1 0 .456 1.948zm-.101 6.228 2.531 2.531a2.003 2.003 0 0 1-2.531-2.532zM5.983 7.397 8.536 9.95a3.993 3.993 0 0 0-.608 2.266c.036 1.022.463 2.033 1.271 2.785s1.846 1.107 2.868 1.071a3.991 3.991 0 0 0 1.984-.608l2.322 2.322A8.962 8.962 0 0 1 11.989 19c-1.734 0-3.285-.559-4.634-1.393-1.119-.692-2.089-1.567-2.894-2.448a18.701 18.701 0 0 1-2.317-3.155 17.275 17.275 0 0 1 3.841-4.607zm-5.69-5.69 4.271 4.271a19.34 19.34 0 0 0-4.445 5.549.999.999 0 0 0-.013.92s.396.789 1.12 1.843a20.553 20.553 0 0 0 1.757 2.218c.894.979 2.004 1.987 3.319 2.8C7.897 20.294 9.808 21 12.012 21a10.98 10.98 0 0 0 5.815-1.759l4.466 4.466a.999.999 0 1 0 1.414-1.414l-8.876-8.876-.007-.007-4.209-4.21-.024-.024L1.707.293A.999.999 0 1 0 .293 1.707z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.106 11.553a.997.997 0 0 0 0 .894s.396.789 1.12 1.843a20.553 20.553 0 0 0 1.757 2.218c.894.979 2.004 1.987 3.319 2.8C7.897 20.294 9.808 21 12 21s4.103-.706 5.698-1.692c1.315-.813 2.425-1.821 3.319-2.8a20.678 20.678 0 0 0 1.757-2.218 17.468 17.468 0 0 0 1.12-1.843.997.997 0 0 0 0-.894s-.396-.789-1.12-1.843a20.553 20.553 0 0 0-1.757-2.218c-.894-.979-2.004-1.987-3.319-2.8C16.103 3.706 14.192 3 12 3s-4.103.706-5.698 1.692c-1.315.813-2.425 1.821-3.319 2.8A20.455 20.455 0 0 0 1.226 9.71a17.468 17.468 0 0 0-1.12 1.843zM2.14 12a18.575 18.575 0 0 1 2.319-3.159c.805-.881 1.775-1.756 2.894-2.448C8.703 5.559 10.254 5 12 5s3.297.559 4.646 1.393c1.119.692 2.089 1.567 2.894 2.448A18.701 18.701 0 0 1 21.859 12a18.575 18.575 0 0 1-2.319 3.159c-.805.881-1.775 1.756-2.894 2.448C15.297 18.441 13.746 19 12 19s-3.297-.559-4.646-1.393c-1.119-.692-2.089-1.567-2.894-2.448A18.701 18.701 0 0 1 2.14 12zM16 12c0-1.104-.449-2.106-1.172-2.828a3.994 3.994 0 0 0-5.656 0 3.994 3.994 0 0 0 0 5.656 3.994 3.994 0 0 0 5.656 0A3.994 3.994 0 0 0 16 12zm-2 0c0 .553-.223 1.051-.586 1.414S12.553 14 12 14s-1.051-.223-1.414-.586S10 12.553 10 12s.223-1.051.586-1.414S11.447 10 12 10s1.051.223 1.414.586S14 11.447 14 12z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-green-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color1, #fff)",
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color2, #38cd3e)",
    d: "M26.667 16c0 5.891-4.776 10.667-10.667 10.667S5.333 21.891 5.333 16 10.109 5.333 16 5.333 26.667 10.109 26.667 16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.ec15ba3a734b7a0993b92a0628004e41.svg";
export { ForwardRef as ReactComponent };